const overlay = () => document.getElementById('loading-overlay');
const textEl = () => document.getElementById('loading-text');
const progressEl = () => document.getElementById('progress-fill');

export function updateLoading(message, progress) {
  const text = textEl();
  const fill = progressEl();
  if (text) text.textContent = message;
  if (fill) fill.style.width = `${progress}%`;
}

export function hideLoading() {
  const el = overlay();
  if (el) {
    el.classList.add('hidden');
    setTimeout(() => el.remove(), 300);
  }
}
